import React, { Component, PropTypes } from 'react';
import CourseStore from 'stores/Course';
import CourseActions from 'actions/Course';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import ListDetail from 'components/Material/ListDetail';
import CourseDetail from 'components/Route/Course/Detail';
import * as Colors from 'components/Material/Styles/Colors';
import { ListItem, Styles, TextField } from 'material-ui';
import { TagSelector, TagList } from 'components/Tags';

const { Spacing } = Styles;

export default class Courses extends mixin(RefluxMixin, Authorizer, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object
  };

  state = {
    filter: {}
  };

  listenToStores() {
    this.listenToStore(CourseStore);
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    CourseActions.filter();
  }

  resetFilter() {
    CourseActions.filter(true);
  }

  selectCourse(course) {
    if (course === null) {
      this.setState({ selected: null });
    } else {
      this.props.router.push(`/course/${course.id}`);
    }
  }

  createListItem(item, leftAvatar, insetChildren) {
    const style = {};
    if (this.state.selected && item.id === this.state.selected.id) {
      style.backgroundColor = Colors.Colors.grey[300].material;
    }

    return (
      <ListItem
        style={style}
        leftAvatar={leftAvatar}
        insetChildren={insetChildren}
        key={'i' + item.id}
        primaryText={item.name}
        secondaryText={<TagList dense tags={item.tagsMap} />}
        onTouchTap={this.selectCourse.bind(this, item)}
      />
    );
  }

  deleteTag = tagName => {
    const filter = {
      ...this.statefilter
    };
    delete filter[tagName];
    this.setState({ filter });
  };

  addTag = tagName => {
    this.setState({
      filter: {
        ...this.state.filter,
        [tagName]: true
      }
    });
  };
  render() {
    const courses = this.state.list || [];
    let filterFunc = (item, searchText, labelProperty) => {
      let hasTags = true;
      Object.keys(this.state.filter).forEach(tagName => {
        let tagsMap = item.tagsMap || {};
        hasTags = hasTags && tagsMap[tagName];
      });
      if (!hasTags) {
        return false;
      }
      if (searchText && searchText !== '') {
        return item[labelProperty].search(searchText) > -1;
      } else {
        return true;
      }
    };

    const tagSelector = (
      <TagSelector
        onAddTag={this.addTag}
        onRemoveTag={this.deleteTag}
        tags={this.state.filter}
        fullWidth
        padded
      />
    );

    return (
      <AppPage
        header={<RulerBar title={this.context.getIntlMessage('Courses')} />}
      >
        <ListDetail
          items={courses}
          filter={filterFunc}
          listItemGenerator={this.createListItem.bind(this)}
          listHeader={tagSelector}
        >
          {this.props.children}
        </ListDetail>
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Courses.js